import { Chip, Card, CardContent, CardMedia, createStyles, Typography, WithStyles, Tooltip } from "@material-ui/core";
import defaultBookImage from "../../../assets/icons/default_book_image.png";
import "./BookCard.css";
import { withStyles } from "@material-ui/core";
import Shiitake from "shiitake";
import accuracyToBand, { accuracyToColor } from "../../../utils/AccuracyToBand";
import { formatTime } from "../Teacher/Table/TableSortAndFormatFunctions";
import StudentFacingData from "../../../interfaces/StudentFacingData";

// Theme-dependent styles
const styles = () =>
  createStyles({
    root: {
      borderRadius: "8px",
      boxShadow: "0px 6px #ff8066",
    },
  });

interface ScreenProps extends WithStyles<typeof styles> {
  bookName: string;
  className: string;
  wordCount: number;
  uniqueWordCount: number;
  estimatedTime: number;
  actualTime?: number;
  isNew: boolean;
  accuracy?: number;
  wordsPerMinute?: number;
  completion: number;
  coverImageUrl?: string;
  studentFacingData?: StudentFacingData;
}

const BookCard = withStyles(styles)((props: ScreenProps) => {
  return (
    <Card className="bookCard" classes={props.classes}>
      <CardMedia
        image={props.coverImageUrl ?? defaultBookImage}
        title="Cover"
        style={{ height: "147px", width: "109px" }}
      />
      <CardContent className="cardContent">
        <div className="resultsDiv">
          {props?.completion > 0 && (
            <div>
              {props.studentFacingData?.accuracy && (
                <Tooltip title="Average Accuracy">
                  <Chip
                    label={accuracyToBand(props.accuracy ?? 0)}
                    size="small"
                    style={{
                      backgroundColor: accuracyToColor(props.accuracy ?? 0),
                      color: "white",
                      fontSize: "8px",
                      marginRight: "6px",
                    }}
                  />
                </Tooltip>
              )}
              {props.studentFacingData?.wordsPerMinute && (
                <Tooltip title="Your Average Reading Speed (Words Per Minute)">
                  <Chip
                    label={Math.round(props.wordsPerMinute || 0) + " WPM"}
                    size="small"
                    style={{ backgroundColor: "#4A91E2", color: "white", fontSize: "8px" }}
                  />
                </Tooltip>
              )}
            </div>
          )}
        </div>
        <div className="bookContent">
          <Typography variant="caption" className="className">
            <Shiitake lines={1}>{props.className}</Shiitake>
          </Typography>
          <Typography variant="h6" className="bookName">
            <Shiitake lines={2}>{props.bookName}</Shiitake>
          </Typography>
          <div className="estimatedTime">
            {props.actualTime
              ? `Time Read: ${formatTime(props.actualTime)}`
              : `${
                  props.estimatedTime === 0
                    ? "Time Estimate Unavailable"
                    : `${formatTime(props.estimatedTime * 60)} Read`
                }`}
          </div>
        </div>
      </CardContent>
    </Card>
  );
});

export default BookCard;
